var map = {
	"./ARG.png": 440,
	"./AUS.png": 544,
	"./BEL.png": 498,
	"./BRA.png": 564,
	"./CAN.png": 816,
	"./CMR.png": 288,
	"./CRC.png": 844,
	"./CRO.png": 862,
	"./DEN.png": 378,
	"./ECU.png": 70,
	"./ENG.png": 287,
	"./ESP.png": 529,
	"./FRA.png": 821,
	"./GER.png": 730,
	"./GHA.png": 509,
	"./IRN.png": 709,
	"./JPN.png": 219,
	"./KOR.png": 83,
	"./KSA.png": 887,
	"./MAR.png": 51,
	"./MEX.png": 612,
	"./NED.png": 243,
	"./POL.png": 90,
	"./POR.png": 793,
	"./QAT.png": 539,
	"./SEN.png": 344,
	"./SRB.png": 571,
	"./SUI.png": 522,
	"./TUN.png": 997,
	"./URU.png": 107,
	"./USA.png": 944,
	"./WAL.png": 932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;